'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'crow';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f520';
var svgPathData = 'M512 192c0 97.2-78.8 176-176 176l-135 0 21.3-5.3C307.9 341.3 368 264.3 368 176l0-88c0-39.8 32.2-72 72-72s72 32.2 72 72l0 104zM352 88l0 59.9-348.7 253.6c-3.6 2.6-4.3 7.6-1.8 11.2 2.1 2.9 5.7 3.9 8.9 2.9l126.5-31.6 149 0 50.7 123 .8 1.4c2.1 3.1 6.1 4.4 9.7 2.9 3.6-1.5 5.5-5.2 4.8-8.9l-.4-1.6-48.2-116.9 32.8 0c15.1 0 29.8-1.7 43.9-5l52.7 128.1 .8 1.4c2.1 3.1 6.1 4.4 9.7 2.9 3.6-1.5 5.5-5.2 4.8-8.9l-.5-1.5-52-126.3c77-25 132.6-97.3 132.6-182.6l0-44 91.4-22.8c11.5-2.9 18.6-14.4 16-25.9-6.2-28.1-30-48.6-58.2-51l-5.7-.2-53.1 0c-14.6-28.5-44.2-48-78.4-48-48.6 0-88 39.4-88 88zM524.7 64l46.8 0c23.2 0 43.3 16.1 48.3 38.7l0 2.3c-.4 2.2-2 4.1-4.3 4.6L528 131.5 528 88c0-8.3-1.2-16.4-3.3-24zM46 390.3l306-222.5 0 8.3c0 81-55.1 151.5-133.7 171.2L46 390.3zM440 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCrow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;